module.exports = __webpack_public_path__ + "img/unfold-icon-2.2c6a6bd5.png";